import '../applied_filter_view.js.coffee';# Added by Script 
import './applied_survey_keyword_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedSurveyFilterView extends Backbone.View
  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @survey = @searchQuery.get('cem_surveys')[0]

  render: ->
    return @ unless @survey
    @_renderAppliedSurveyItemFilter(name, attributes) for name, attributes of @survey.items if @survey.items
    @_renderAppliedSurveyKeywordFilter(name, attributes) for name, attributes of @survey.keywords if @_hasKeywords()
    @

  _hasKeywords: ->
    return false unless @survey.keywords
    for _name, attributes of @survey.keywords
      for attribute of attributes
        return true if attribute in ['primary_keywords', 'secondary_keywords', 'excluded_keywords']
    false

  destroy: ->
    this.remove()
    return false

  _renderAppliedSurveyItemFilter: (name, attributes) ->
    @$el.append @_appliedSurveyItemFilterView(name, attributes).render().el

  _appliedSurveyItemFilterView: (name, attributes) ->
    new Monitoring.Views.SocialContents.Filters.AppliedSurveyItemFilterView(
      $.extend({name: name, values: attributes.values, alias: attributes.name, survey: @survey}, @options)
    )

  _renderAppliedSurveyKeywordFilter: (name, attributes) ->
    @$el.append @_appliedSurveyKeywordFilterView(name, attributes).render().el

  _appliedSurveyKeywordFilterView: (name, attributes) ->
    new Monitoring.Views.SocialContents.Filters.AppliedSurveyKeywordFilterView
      searchQuery: @searchQuery
      name: name
      alias: attributes.name
      survey: @survey

class Monitoring.Views.SocialContents.Filters.AppliedSurveyItemFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView

  initialize: (@options = {}) ->
    super
    @name = @options.name
    @alias = @options.alias
    @values = @options.values
    @surveyId = @options.survey.id

  getAppliedValues: ->
    @values

  removeFilter: (value) ->
    @searchQuery.removeSurveyItem(@name, value, @surveyId)

  clear: (event) =>
    survey = _.find(@searchQuery.get('cem_surveys'), (s) => parseInt(s.id) == parseInt(@surveyId) )
    survey.items[@name] = {}
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
